import { z, ZodObject, ZodRawShape, ZodTypeAny } from 'zod';

type ZodShape<T> = {
    // Require all the keys from T
    [key in keyof T]-?: undefined extends T[key]
        ? // When optional, require the type to be optional in zod
          z.ZodOptionalType<z.ZodType<T[key]>>
        : z.ZodType<T[key]>;
};
export const zObject = <T, V extends ZodTypeAny = ZodTypeAny>(
    shape: ZodShape<T>,
): ZodObject<typeof shape, 'strip', V, T, T> => {
    //@ts-ignore T will not define by ZodShape<T>
    return z.object(shape);
};
export const zSchema = <T, U extends ZodRawShape, V extends ZodTypeAny = ZodTypeAny>(
    schema: ZodObject<U, 'strip', V, T, T>,
) => {
    return schema;
};
